import React from "react"
import { useLocation } from "react-router-dom";
import HeaderFullSize from "./HeaderFullSize";
import HeaderMini from "./HeaderMini";
import useViewportMinimized from "../../../Code/useViewportMinimized";

export default function Header({ isDonateYourCard: isDonateYourCardProp }) {
  const showMinimized = useViewportMinimized();

  const location = useLocation();
  const isDonateYourCard = isDonateYourCardProp || location.state?.isDonateYourCard;

  return showMinimized
    ? <HeaderMini isDonateYourCard={isDonateYourCard} />
    : <HeaderFullSize isDonateYourCard={isDonateYourCard} />;
}